<template>
	<div class="page-in">


        <intervento-elenco tipologia="educational workshop" giorno="2019-05-20"></intervento-elenco>
        <intervento-elenco tipologia="educational workshop" giorno="2019-05-21"></intervento-elenco>
        <intervento-elenco tipologia="educational workshop" giorno="2019-05-22"></intervento-elenco>

    
  </div>
</template>

<script>
import interventoElenco from './Educational-workshops-elenco.vue'
export default {
  name: 'educational-workshops',
  components: {
    interventoElenco
  },
  data () {
    return {
      loading: true,

      
      page: {title:'', testo:''}
    }
  },
  created () {
  },
  methods: {
  }  
}

</script>
